import { render, staticRenderFns } from "./CardGiftCard.vue?vue&type=template&id=33c02d6c&"
import script from "./CardGiftCard.vue?vue&type=script&lang=ts&"
export * from "./CardGiftCard.vue?vue&type=script&lang=ts&"
import style0 from "./CardGiftCard.vue?vue&type=style&index=0&id=33c02d6c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports